import client from "graphql/client";
import { loader } from "graphql.macro";

const assignOwnersToDossierMutation = loader("graphql/mutations/dossier/assignOwnersToDossier.graphql");

export default function assignOwnersToDossierAction(id, sequenceNumber, ownerIds) {
    return () => {
        const series = { id, sequenceNumber };
        return client.mutate({
            mutation: assignOwnersToDossierMutation,
            variables: { series, owners: ownerIds }
        });
    };
}